
export const provincesListActions = {

  FETCH_PROVINCES_FAILED: 'FETCH_PROVINCES_FAILED',
  FETCH_PROVINCES_SUCCESS: 'FETCH_PROVINCES_SUCCESS',
  FETCH_PROVINCES_PENDING: 'FETCH_PROVINCES_PENDING',
  LOAD_PROVINCES: 'LOAD_PROVINCES',

  fetchProvincesFailed: error => ({
    type: provincesListActions.FETCH_PROVINCES_FAILED,
    payload: error
  }),

  fetchProvincesSuccess: (id, {data}) => ({
    type: provincesListActions.FETCH_PROVINCES_SUCCESS,
    payload: {
      id: id,
      items: data,
      count: data.length,
    }
  }),

  fetchProvincesPending: id => ({
    type: provincesListActions.FETCH_PROVINCES_PENDING,
    payload: {
      id
    }
  }),

  loadProvinces: (sessionId) => ({
    type: provincesListActions.LOAD_PROVINCES,
    payload: {
      id: 'provincesall',
      sessionId
    }
  }),
}

export const provincesListRequestActions = {
  failed: provincesListActions.fetchProvincesFailed,
  success: provincesListActions.fetchProvincesSuccess,
  pending: provincesListActions.fetchProvincesPending
};
